import React, { useEffect, useState } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { IoMdArrowRoundBack } from "react-icons/io";
import { changePassword } from "../../../redux/features/ownerSlice";
import styles from "./CustomerChangepassword.module.scss";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";
import { Zoom } from "react-toastify";
import { Formik } from "formik";
import * as yup from "yup";
import failedMessage from "../../../messages/Failed";
import successMessage from "../../../messages/Successful";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CustomerAcceptOTP from "../acceptotp/CustomerAcceptOTP";
import { customerSendOTP } from "../../../redux/features/customerSlice";

export default function CustomerChangepassowrd() {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const token = useSelector((state) => state.cpc.user.login.token);
  const roleName = useSelector((state) => state.cpc.user.login.roleName);
  const phoneNumber = useSelector(
    (state) => state.cpc.user.login.customerPhoneNumber
  );

  const changePasswordValidation = yup.object().shape({
    oldPassword: yup.string().required("Old password is required"),
    newPassword: yup.string().required("New password is required"),
    confirmPassword: yup
      .string()
      .required("Confirm password is required")
      .oneOf([yup.ref("newPassword"), null], "Passwords must match"),
  });

  const { t, i18n } = useTranslation();

  const [customerOtp, setCustomerOtp] = useState(false);
  const [verfCode, setVerfCode] = useState("");
  const [changePasswordInfo, setChangePasswordInfo] = useState({
    phoneNumber: "",
    currentPassword: "",
    newPassword: "",
  });

  return (
    <div className={`${styles.changePasswordContent} p-3`}>
      <Container>
        <Row>
          <Col xs={12}>
            <h3 className={`${styles.teamTitle}`}>
              <IoMdArrowRoundBack
                className={`${styles.backBtn} fs-4 me-2`}
                onClick={() => {
                  if (roleName === "Trader") {
                    navigate("/trader/dashboard/home");
                  }
                  if (roleName === "Owner") {
                    navigate("/owner/dashboard/balance");
                  }
                  if (roleName === "Consumer") {
                    navigate("/customer/dashboard/home");
                  }
                }}
              />
              {t("changePassword")}
            </h3>
          </Col>
        </Row>
        <Col xs={12} md={{ span: 8, offset: 2 }}>
          <Row className="mt-3">
            <Formik
              initialValues={{
                phoneNumber: "",
                oldPassword: "",
                newPassword: "",
                confirmPassword: "",
              }}
              onSubmit={(values, actions) => {
                setTimeout(() => {
                  actions.setSubmitting(false);
                }, 3000);
                dispatch(
                  customerSendOTP({
                    mobileNumber: phoneNumber,
                  })
                ).then((res) => {
                  if (res.payload.data.statusCode === 200) {
                    setCustomerOtp(true);
                    setChangePasswordInfo({
                      phoneNumber: phoneNumber,
                      currentPassword: values.oldPassword,
                      newPassword: values.newPassword,
                    });
                    setVerfCode(res.payload.data.verificationCode);
                  }
                });
              }}
              validationSchema={changePasswordValidation}
            >
              {({
                values,
                errors,
                touched,
                handleChange,
                handleSubmit,
                setFieldValue,
                isSubmitting,
              }) => {
                return (
                  <Form
                    id="changePassword"
                    onSubmit={handleSubmit}
                    className={`${styles.changePasswordFormContent} p-3 p-md-4`}
                  >
                    <Row className="mb-3">
                      <Form.Group as={Col} xs={12} sm={12} className="mb-3">
                        <Form.Label className={`${styles.addInputLabel}`}>
                          {t("phoneNumber")}
                        </Form.Label>
                        <Form.Control
                          type="tel"
                          maxLength={11}
                          placeholder={t("phoneNumber")}
                          className={`${styles.addInput}`}
                          name="phoneNumber"
                          id="phoneNumber"
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            var char = String.fromCharCode(e.which);
                            if (!/[0-9]/.test(char)) {
                              e.preventDefault();
                            }
                          }}
                          disabled={true}
                          value={phoneNumber}
                        />
                      </Form.Group>
                      <Form.Group as={Col} xs={12} sm={12} className="mb-3">
                        <Form.Label className={`${styles.addInputLabel}`}>
                          {t("oldPass")}
                        </Form.Label>
                        <Form.Control
                          type="password"
                          maxLength={4}
                          placeholder={t("oldPass")}
                          className={`${styles.addInput}`}
                          name="oldPassword"
                          id="oldPassword"
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            var char = String.fromCharCode(e.which);
                            if (!/[0-9]/.test(char)) {
                              e.preventDefault();
                            }
                          }}
                          value={values.oldPassword}
                        />
                        {errors.oldPassword && touched.oldPassword && (
                          <Form.Text className="text-error">
                            {errors.oldPassword}
                          </Form.Text>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} xs={12} sm={12} className="mb-3">
                        <Form.Label className={`${styles.addInputLabel}`}>
                          {t("newPass")}
                        </Form.Label>
                        <Form.Control
                          type="password"
                          maxLength={4}
                          placeholder={t("newPass")}
                          className={`${styles.addInput}`}
                          name="newPassword"
                          id="newPassword"
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            var char = String.fromCharCode(e.which);
                            if (!/[0-9]/.test(char)) {
                              e.preventDefault();
                            }
                          }}
                          value={values.newPassword}
                        />
                        {errors.newPassword && touched.newPassword && (
                          <Form.Text className="text-error">
                            {errors.newPassword}
                          </Form.Text>
                        )}
                      </Form.Group>
                      <Form.Group as={Col} xs={12} sm={12} className="mb-3">
                        <Form.Label className={`${styles.addInputLabel}`}>
                          {t("confirmPass")}
                        </Form.Label>
                        <Form.Control
                          type="password"
                          maxLength={4}
                          placeholder={t("confirmPass")}
                          className={`${styles.addInput}`}
                          name="confirmPassword"
                          id="confirmPassword"
                          onChange={handleChange}
                          onKeyPress={(e) => {
                            var char = String.fromCharCode(e.which);
                            if (!/[0-9]/.test(char)) {
                              e.preventDefault();
                            }
                          }}
                          value={values.confirmPassword}
                        />
                        {errors.confirmPassword && touched.confirmPassword && (
                          <Form.Text className="text-error">
                            {errors.confirmPassword}
                          </Form.Text>
                        )}
                      </Form.Group>
                      <Col xs={12} className="mt-3 text-center">
                        <Button
                          type="submit"
                          size="md"
                          variant="danger"
                          form="changePassword"
                          className={`${styles.saveBtn}`}
                          disabled={isSubmitting}
                        >
                          {t("changePassword")}
                        </Button>
                      </Col>
                    </Row>
                  </Form>
                );
              }}
            </Formik>
          </Row>
        </Col>
      </Container>
      <CustomerAcceptOTP
        show={customerOtp}
        onHide={() => {
          setCustomerOtp(false);
        }}
        verfcode={verfCode}
        changepasswordinfo={changePasswordInfo}
      />
    </div>
  );
}
